<div class="d-flex flex-row justify-content-between">
	<h1 class="page-title">Financial Report</h1>
</div>
<hr class="page-title"/>

<form (ngSubmit)="generateReport();" [formGroup]="formGroup">
    <div class="row">
        <div class="col-md-6">
            <pcg-control-group  label="Select Year/Month">
                <pcg-select  
                    placeholder="Select a Year/Month" [sendFormData]="false" pcgControlRef
                    dataSource="api/Select/MonthYear" formControlName="monthYearString">
                </pcg-select>
            </pcg-control-group>
        </div>
        <div class="col-md-6">    
            <div id="actionElements" style="display: flex; justify-content: right;">
                <pcg-fixed-buttons>
                    <button class="btn btn-save btn-lg" type="submit">Download to Excel</button>
                </pcg-fixed-buttons>
            </div>
        </div>
    </div>
</form>